require('./assets/scss/app-picture.scss');
require('./assets/js/app');